import Head from 'next/head';

import { Meta } from '@/components/common/Meta';
import { OpenGraph } from '@/components/common/OpenGraph';
import { env } from '@/lib/utils/env';
import { CampaignTemplate } from '@/pages/campaign';

export default function CampaignPage() {
  return (
    <>
      <Meta
        title='개발자 커리어 개척 캠프 항해99 | 잔디 기부 캠페인'
        author='항해99'
        description='세상의 성장에 기여하세요'
        keywords='코딩 부트캠프, 주니어 개발자, 웹개발, 코딩공부, 프로그래밍, 파이썬, 코딩학원, 코딩 스터디, 부트캠프, 개발자, 코딩, 개발자 취업, AWS, 웹서버, 서버, 클라이언트, 자바스크립트, 리액트, React, Spring, 스프링, 앱개발, React Native, 프론트엔드, 백엔드, 풀스택, 잔디, 잔디 기부 캠페인, 잔디 기부, 항해99'
        url={`${env.NEXT_PUBLIC_PAGE_URL}/campaign`}
        thumbnail='/images/campaign/campaign_og.webp'
      />
      <OpenGraph
        title='개발자 커리어 개척 캠프 항해99 | 잔디 기부 캠페인'
        description='세상의 성장에 기여하세요'
        image='/images/campaign/campaign_og.webp'
        imageWidth={400}
        imageHeight={400}
        imageAlt='개발자 커리어 개척 캠프 항해99 | 잔디 기부 캠페인'
        url={`${env.NEXT_PUBLIC_PAGE_URL}/campaign`}
        siteName='항해99'
        imageType='image/webp'
        locale='ko_KR'
      />
      <Head>
        <style>{`
          body {
            background-color: rgb(20, 22, 23);
          }
        `}</style>
      </Head>
      <CampaignTemplate />
    </>
  );
}

export const getServerSideProps = async () => {
  return {
    props: {},
  };
};
